import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, } from "@angular/forms";
import { Helper } from "src/app/shared/helpers/helper";
import { globalConst } from "src/app/shared/helpers/constants";
import { Alert } from "src/app/shared/class/Alert";
import * as moment from "moment";
moment.locale("pt-br");
import * as _ from "lodash";
import { ServiceRequest } from "src/app/shared/models/service-request.model";
import { Pdf } from "src/app/shared/class/Pdf.class";
import { Agent } from "src/app/shared/models/agent.model";
export class ReportServiceRequestComponent {
    constructor(authService, spinner, serviceRequestService, fb) {
        this.authService = authService;
        this.spinner = spinner;
        this.serviceRequestService = serviceRequestService;
        this.fb = fb;
        this.goback = "";
        this.userLogged = {};
        this.startDate = new FormControl();
        this.minStartDate = new Date();
        this.strStartDate = "";
        this.endDate = new FormControl();
        this.minEndDate = null;
        this.strEndDate = "";
        this.agentOptions = [];
        this.filteredAgentOptions = [];
        this.companyOptions = [];
        this.filteredCompanyOptions = this.companyOptions;
        this.serviceRequests = [];
        this.userLogged = this.authService.getUserLogged();
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.spinner.show();
            try {
                this.form = new FormGroup({
                    startDate: new FormControl(""),
                    endDate: new FormControl(""),
                    company: this.fb.control(""),
                    agent: this.fb.control(""),
                });
                yield this.loadCompanyOptions();
                yield this.loadAgents();
                this.spinner.hide();
            }
            catch (error) {
                this.spinner.hide();
            }
        });
    }
    loadCompanyOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getCompanies();
                this.companyOptions =
                    this.userLogged.type === globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.userLogged.companiesAssociate;
                this.filteredCompanyOptions = this.companyOptions;
                if (!this.companyOptions.length) {
                    Alert.warning(Alert.getMessage().errors.company.emptySearch);
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadAgents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getAgents();
                this.agentOptions =
                    data.status === undefined ? Agent.orderAgentByName(data) : [];
                this.filteredAgentOptions = this.agentOptions;
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    onChangeStartDate(event) {
        this.strStartDate = Helper.getFormattedBrDate(event.value);
        this.endDate = new FormControl();
        this.minEndDate = new Date(event.value);
        this.strEndDate = "";
        this.form.controls.endDate.setValue("");
        this.form.controls.endDate.updateValueAndValidity();
    }
    onChangeEndDate(event) {
        this.strEndDate = Helper.getFormattedBrDate(event.value);
    }
    clearPeriod() {
        this.strStartDate = "";
        this.form.controls.startDate.setValue("");
        this.form.controls.startDate.updateValueAndValidity();
        this.strEndDate = "";
        this.form.controls.endDate.setValue("");
        this.form.controls.endDate.updateValueAndValidity();
    }
    displayDescription(object) {
        return !_.isEmpty(object) ? `${object.description}` : "";
    }
    filterCompanyOptions(value) {
        value = value.trim();
        this.filteredCompanyOptions = value
            ? this._filterCompany(value)
            : this.companyOptions.slice();
    }
    _filterCompany(name) {
        const filterValue = name.toLowerCase();
        const searchName = this.companyOptions.filter((option) => option.description.toLowerCase().includes(filterValue));
        if (searchName.length) {
            return searchName;
        }
        return this.companyOptions.filter((option) => option.description.toLowerCase().includes(filterValue));
    }
    displayAgent(object) {
        return !_.isEmpty(object) ? `${object.name}` : "";
    }
    filterAgentOptions(value) {
        value = value.trim();
        this.filteredAgentOptions = value
            ? this._filterAgent(value)
            : this.agentOptions.slice();
    }
    _filterAgent(name) {
        const filterValue = name.toLowerCase();
        const searchName = this.agentOptions.filter((option) => option.name.toLowerCase().includes(filterValue));
        if (searchName.length) {
            return searchName;
        }
        return this.agentOptions.filter((option) => option.name.toLowerCase().includes(filterValue));
    }
    onSubmit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.validateForm()) {
                const data = yield this.serviceRequestService.getSchedules(this.getQueryParams());
                this.serviceRequests =
                    data.status === undefined ? ServiceRequest.orderByDate(data) : [];
                this.viewPdf();
            }
            else {
                Alert.warning(Alert.getMessage().errors.requiredFilters);
            }
        });
    }
    getQueryParams() {
        const params = [];
        const filters = this.form.controls;
        if (!_.isNull(filters.agent.value.id) && filters.agent.value.id > 0) {
            params.push({ id: "agent", value: filters.agent.value.id });
        }
        if (!_.isNull(filters.company.value.alternativeIdentifier) &&
            filters.company.value.alternativeIdentifier > 0) {
            params.push({
                id: "company",
                value: filters.company.value.alternativeIdentifier,
            });
        }
        if (!_.isNull(filters.startDate.value) && filters.startDate.value !== "") {
            params.push({
                id: "startDate",
                value: moment(filters.startDate.value).format("YYYY-MM-DD"),
            });
        }
        if (!_.isNull(filters.endDate.value) && filters.endDate.value !== "") {
            params.push({
                id: "endDate",
                value: moment(filters.endDate.value).format("YYYY-MM-DD"),
            });
        }
        /*  if (!_.isNull(filters.regional.value) && filters.regional.value > 0) {
           params.push({ id: 'regional', value: filters.regional.value });
         }
    
         if (!_.isNull(filters.serviceLocal.value) && filters.serviceLocal.value > 0) {
           params.push({ id: 'serviceLocal', value: filters.serviceLocal.value });
         } */
        return this.prepareQueryParams(params);
    }
    prepareQueryParams(params) {
        let queryParams = "";
        params.map((param) => {
            queryParams = queryParams === "" ? "" : `${queryParams}&`;
            queryParams = `${queryParams}${param.id}=${param.value}`;
        });
        return queryParams;
    }
    validateForm() {
        if (this.form.controls.startDate.value !== "" ||
            this.form.controls.endDate.value !== "" ||
            this.form.controls.company.value !== "" ||
            this.form.controls.agent.value !== "") {
            return true;
        }
        else {
            return false;
        }
    }
    viewPdf() {
        const pdf = this.makePdf(this.serviceRequests);
        window.open(URL.createObjectURL(pdf.output("blob")));
    }
    makePdf(serviceRequests) {
        // tslint:disable: max-line-length
        const pdf = new Pdf({
            documentTitle: `Relatório Solicitações de Serviço.pdf`,
            header: true,
            footer: true,
        });
        pdf.setFont("times");
        pdf.pullLine(8);
        pdf.writeClauseTitle("RELATÓRIO DE SOLICITAÇÕES DE SERVIÇO");
        pdf.pullLine(10);
        if (serviceRequests.length > 1) {
            pdf.writeJustifyText({
                text: `(${serviceRequests.length}) Solicitações encontradas`,
            });
        }
        else {
            pdf.writeJustifyText({
                text: `(${serviceRequests.length}) Solicitação encontrada`,
            });
        }
        pdf.pullLine(10);
        serviceRequests.map((serviceRequest) => {
            pdf.writeJustifyText({
                text: `Data: ${moment(serviceRequest.date).format("L")}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `Cliente: ${serviceRequest.companyDescription}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `Regional: ${serviceRequest.regionalDescription}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `Local: ${serviceRequest.serviceLocalDescription}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `Técnico: ${serviceRequest.agentName}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `OS: ${serviceRequest.id}`,
            });
            pdf.pullLine(5);
            pdf.writeJustifyText({
                text: `Link: https://center.umov.me/CenterWeb/report/schedule/${serviceRequest.id}/${serviceRequest.accesstoken}`,
            });
            pdf.pullLine(8);
            pdf.setLineWidth(0.1);
            pdf.line(10, pdf.getY(), 200, pdf.getY());
            pdf.pullLine(8);
        });
        pdf.pullLine(15);
        return pdf;
    }
}
